const ContentType = {
    JSON: 'application/json',
    FORM: 'application/x-www-form-urlencoded',
    FORMDATA: 'multipart/form-data'
};

export { ContentType };
